import { SparkleCursor } from "@/components/SparkleCursor";
import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { EditorialMarquee } from "@/components/EditorialMarquee";
import { Manifesto } from "@/components/Manifesto";
import { Services } from "@/components/Services";
import { Roster } from "@/components/Roster";
import { Listen } from "@/components/Listen";
import { Work } from "@/components/Work";
import { Merch } from "@/components/Merch";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";

export default function Landing() {
  return (
    <div data-testid="landing-page" className="bg-[#FDFBF7] text-[#2D1A13]">
      <div className="noise-overlay" />
      <SparkleCursor />
      <Nav />
      <main>
        <Hero />
        <EditorialMarquee />
        <Manifesto />
        <Services />
        <Roster />
        <Listen />
        <Work />
        <Merch />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
